/** 登录注册相关接口 */
import request from '@/utils/util.request';

/**
 * @desc 登录页，预加载
 * @param {string} uuid		包含用户的openid等信息，来自跳转后的url
 */
export const on_board = (data) => {
	return request({
		url: '/signin/onboard',
		data,
		// loading: false,
	});
};

/**
 * @desc 密码账号登录
 * @param {string} username 用户手机号
 * @param {string} uuid		包含用户的openid等信息，来自跳转后的url
 * @param {string} password
 */
export const account_in = (data) => {
	return request({
		url: '/signin/accountin',
		data,
	});
};

/**
 * @desc 游客登录
 * @param {string} uuid		包含用户的openid等信息，来自跳转后的url
 */
export const guest_in = (data) => {
	return request({
		url: '/signin/guestin',
		data,
	});
};

/**
 * @desc 免密码登录
 * @param {string} uuid		包含用户的openid等信息，来自跳转后的url
 */
export const wx_in = (data) => {
	return request({
		url: '/signin/wxin',
		data,
	});
};

/**
 * @desc 企业用户免密码登录
 * @param {string} uuid		包含用户的openid等信息，来自跳转后的url
 */
export const enterprise_in = (data) => {
	return request({
		url: '/signin/enterprisein',
		data,
	});
};

/**
 * @desc 用户退出登陆
 */
export const signout = (data) => {
	return request({
		url: '/site/signout',
		data,
	});
};

/**
 * @desc 用户注册
 * @param {string} username
 * @param {string} phone
 * @param {string} code
 * @param {string} password (md5)
 * @param {string} uuid  来自跳转的url的参数
 */
export const register = (data) => {
	return request({
		url: '/login/register',
		data,
	});
};

/**
 * @desc 发送手机验证码
 * @param {string} phone 手机号码
 * @param {string} msg_type  reset_password | register
 * @param {string} uuid  来自跳转的url的参数
 */
export const send_sms_code = (data) => {
	return request({
		url: '/site/smsvalidcode',
		data,
	});
};

/**
 * @desc 重置密码
 * @param {string} phone 手机号码
 * @param {string} code  验证码
 * @param {string} uuid  来自跳转的url
 */
export const reset_password = (data) => {
	return request({
		url: '/site/resetpassword',
		data,
	});
};

